import { LOGOUT } from 'src/config';
import { getData } from 'src/api/apiGet';

export const logoutRequest = () => {
  return getData(LOGOUT).then(response => {
    return response;
  });
};
